var React = require('react');

function TdcSimpleLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.003 23.892a23.97 23.97 0 011.815-9.067 2.52 2.52 0 012.327-1.566h6.603a2.51 2.51 0 002.51-2.511V4.145a2.52 2.52 0 011.567-2.327C17.622.662 20.262.12 23.892 0H24c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24l.003-.108z"}));
}

TdcSimpleLogo.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = TdcSimpleLogo;

TdcSimpleLogo.default = TdcSimpleLogo;
